// @ts-expect-error
import {createReducer} from 'redux-act';

import * as actions from './leads-actions';

const defaultStat = {value: 0, formatted: '0', prefix: '$', suffix: ''} as const;
const defaultSummaryStats = {
    value: {mean: defaultStat, sum: defaultStat},
    openedTime: {mean: defaultStat},
    winRate: {value: defaultStat},
} as const;

export const DEFAULT_ENGAGEMENT_LEADS_STATE = {
    timeseriesChart: {
        isLoading: true,
        isTimedOut: false,
        isErrored: false,
        chartData: null,
        prefix: '$',
    },
    leadsList: {
        isLoading: true,
        isFirstLoad: true,
        errorMessage: undefined,
        listItems: [],
        meta: {},
    },
    summaryStats: {
        isLoading: true,
        stats: defaultSummaryStats,
    },
} as const;

export const engagementLeadsReducer = createReducer(
    {
        // @ts-expect-error
        [actions.requestReportData]: (state) => {
            const newChartState = {
                ...state.timeseriesChart,
                isLoading: true,
                isTimedOut: false,
                isErrored: false,
            } as const;

            return {...state, timeseriesChart: newChartState};
        },
        // @ts-expect-error
        [actions.updateReportChartData]: (state, {chartData}) => {
            const newChartState = {
                ...state.timeseriesChart,
                isLoading: false,
                isTimedOut: false,
                isErrored: false,
                chartData,
            } as const;

            return {...state, timeseriesChart: newChartState};
        },
        // @ts-expect-error
        [actions.failReportChartData]: (state, err) => {
            if (err) {
                if (err.status === 504 || err.status === 502) {
                    const newChartState = {
                        ...state.timeseriesChart,
                        chartData: null,
                        isLoading: false,
                        isTimedOut: true,
                        isErrored: false,
                    } as const;

                    return {...state, timeseriesChart: newChartState};
                } else {
                    const newChartState = {
                        ...state.timeseriesChart,
                        chartData: null,
                        isLoading: false,
                        isTimedOut: false,
                        isErrored: true,
                    } as const;

                    return {...state, timeseriesChart: newChartState};
                }
            }

            return state;
        },
        // List reducers
        // @ts-expect-error
        [actions.requestListData]: (state) => {
            return {
                ...state,
                leadsList: {...state.leadsList, isLoading: true, errorMessage: undefined},
                summaryStats: {...state.summaryStats, isLoading: true, stats: defaultSummaryStats},
            };
        },
        // @ts-expect-error
        [actions.updateListData]: (state, {meta, listItems}) => {
            return {
                ...state,
                leadsList: {
                    ...state.leadsList,
                    isLoading: false,
                    isFirstLoad: false,
                    meta: meta,
                    listItems: listItems,
                    errorMessage: undefined,
                },
            };
        },
        // @ts-expect-error
        [actions.updateListSummaryData]: (state, {meta}) => {
            return {
                ...state,
                summaryStats: {...state.summaryStats, isLoading: false, stats: meta.stats},
            };
        },
        // @ts-expect-error
        [actions.failListData]: (state, err) => {
            return {
                ...state,
                leadsList: {
                    ...state.leadsList,
                    isLoading: false,
                    isFirstLoad: false,
                    errorMessage: err,
                },
            };
        },
    },
    DEFAULT_ENGAGEMENT_LEADS_STATE
);
